var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseToggleSwitcher',{attrs:{"value":_vm.value,"size":_vm.size,"fillBg":"background-success-default","disabledBg":"v1-grey-10"},on:{"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }